import { useState } from 'react';

const Carousel = (arry) => {
    // ดึงตัวเลขจากท้าย URL (เช่น /0, /1, /2 หรือ 1.jpg) มา Sort จากน้อยไปมาก
    const data = arry?.data?.slice().sort((a, b) => {
        const getNum = (str) => {
            const match = str.match(/(\d+)(?=[^0-9]*$)/);
            return match ? parseInt(match[0]) : 0;
        };
        return getNum(a) - getNum(b);
    });

    const [activeIndex, setActiveIndex] = useState(0);

    const handlePrevClick = () => {
        setActiveIndex((prevIndex) => (prevIndex === 0 ? data?.length - 1 : prevIndex - 1));
    };

    const handleNextClick = () => {
        setActiveIndex((prevIndex) => (prevIndex === data?.length - 1 ? 0 : prevIndex + 1));
    };

    return (
        <div className="relative w-full max-w-screen-xl mx-auto group overflow-hidden rounded-3xl shadow-2xl bg-gray-50">
            {/* Image Display พื้นที่แสดงรูปภาพ */}
            <div className="relative h-[350px] md:h-[550px] w-full overflow-hidden">
                {data?.map((slide, index) => (
                    <div
                        key={index}
                        className={`absolute inset-0 w-full h-full transition-all duration-700 ease-in-out transform ${
                            activeIndex === index 
                            ? "opacity-100 scale-100" 
                            : "opacity-0 scale-105 pointer-events-none"
                        }`}
                    >
                        <img
                            src={slide.split(",")[0]}
                            className="w-full h-full object-contain"
                            alt={`Slide ${index + 1}`}
                        />
                        {/* Overlay ไล่เฉดสีให้ดูพรีเมียม */}
                        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/30" />
                    </div>
                ))}
            </div>

            {/* Navigation Buttons - ดีไซน์ใหม่แบบกระจก (Glassmorphism) */}
            <button
                className="absolute top-1/2 left-4 -translate-y-1/2 z-20 bg-white/20 backdrop-blur-lg border border-white/40 text-white p-3 rounded-full transition-all duration-300 hover:bg-orange-500 hover:border-orange-500 hover:scale-110 active:scale-95 opacity-0 group-hover:opacity-100 shadow-xl"
                onClick={handlePrevClick}
            >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" className="w-5 h-5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
                </svg>
            </button>

            <button
                className="absolute top-1/2 right-4 -translate-y-1/2 z-20 bg-white/20 backdrop-blur-lg border border-white/40 text-white p-3 rounded-full transition-all duration-300 hover:bg-orange-500 hover:border-orange-500 hover:scale-110 active:scale-95 opacity-0 group-hover:opacity-100 shadow-xl"
                onClick={handleNextClick}
            >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor" className="w-5 h-5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                </svg>
            </button>

            {/* Indicators - จุดบอกตำแหน่งด้านล่างที่ขยับได้ (Animated Dots) */}
            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2 z-20">
                {data?.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => setActiveIndex(index)}
                        className={`transition-all duration-500 rounded-full ${
                            activeIndex === index 
                            ? "w-8 h-2 bg-orange-500" 
                            : "w-2 h-2 bg-white/60 hover:bg-white"
                        }`}
                    />
                ))}
            </div>
        </div>
    );
}

export default Carousel;